import React from 'react'
import { CO2El } from '../style'
import { Dimmer, Loader } from 'semantic-ui-react'
import styled from 'styled-components'
import { LAST_STEP_INDEX } from '.'
interface Props {
  step: {
    icon?: string,
    title: string
    image?: string
    style?: any
  }
  active: boolean
  index: number
  isLoading?: boolean
  handleStepClick: () => void
  breed: boolean
  isLoadingResults?: boolean
}

const StyledWrapper = styled.div<{ $active: boolean }>`
display: flex;
flex-direction: column;
align-items: center;
`

const Step: React.FC<Props> = (props) => {

  const {
    step,
    active,
    index,
    isLoading,
    handleStepClick,
    breed,
    isLoadingResults
  } = props

  const isFirstStep = index === 0

  const isLastStep = index === LAST_STEP_INDEX

  const clickAble = breed && !isLoadingResults && !isLastStep

  function renderSpinner() {
    return <Dimmer inverted active={isLoading}>
      <Loader active={isLoading} />
    </Dimmer>
  }

  function renderIcon() {
    return <div>
      {step?.image ? <img src={step.image} style={props.step.style} /> : step.icon}
    </div>
  }

  function renderStepContent() {
    return <StyledWrapper
      onClick={() => clickAble && handleStepClick()}
      $active={active}
    >
      <CO2El.StepIcon
        $active={active}
        $dataLoaded={Boolean(clickAble)}
      >
        {isLoading ? renderSpinner() : renderIcon()}
      </CO2El.StepIcon>
      <div
        style={{
          width: isFirstStep ? 'fit-content' : 'max-content',
          cursor: clickAble ? 'pointer' : 'default'
        }}
        className='stepTitle'>
        {step.title}
      </div>
    </StyledWrapper>
  }

  return <CO2El.Step key={step.icon} $active={active}>
    {renderStepContent()}
  </CO2El.Step>
}
export default Step